export default {"src":"/_next/static/media/acquired_badge.9fd41f3a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};